import { render, staticRenderFns } from "./QuoteOccurrenceResumeByItemDialog.vue?vue&type=template&id=3c2a88a0&"
import script from "./QuoteOccurrenceResumeByItemDialog.vue?vue&type=script&lang=js&"
export * from "./QuoteOccurrenceResumeByItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports